import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import Image from '../common/image';
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import { ToastContainer, toast } from 'react-toastify';
import config from "../../envconfig";
import CustomDropdown from '../common/CustomDropdown';
import axios from 'axios';
import { UserContext } from '../common/UserContext';

function CGMList() {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const [userData, setUserData] = useState([]);
    const [message, setMessage] = useState('');
    const [firstFilter, setFirstFilter] = useState('');
    const [firstFilterSearch, setFirstFilterSearch] = useState('');
    const [secondFilter, setSecondFilter] = useState('');
    const [secondFilterSearch, setSecondFilterSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [companyIdToSuspend, setCompanyIdToSuspend] = useState(null);
    const [remark, setRemark] = useState('');
    const [remarkError, setRemarkError] = useState(false);

    const [firstFilterOptions, setFirstFilterOptions] = useState([
        { value: 'CGM_CompanyGroupName', label: 'Company Group Name', disabled: false },
        { value: 'CGM_CompanyGroupCode', label: 'Company Group Code', disabled: false }
    ]);

    const [secondFilterOptions, setSecondFilterOptions] = useState([
        { value: 'CGM_CompanyGroupName', label: 'Company Group Name', disabled: false },
        { value: 'CGM_CompanyGroupCode', label: 'Company Group Code', disabled: false },
    ]);

    useEffect(() => {
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);

    const [isSelectOpen, setIsSelectOpen] = useState(false);
const toastRef = useRef(null);
const showToast = (type, message, options = {}) => {
  if (toastRef.current && toast.isActive(toastRef.current)) {
    toast.update(toastRef.current, {
      render: message,
      type,
      autoClose: 3000,
      ...options,
    });
  } else {
    toastRef.current = toast[type](message, {
      autoClose: 3000,
      ...options,
    });
  }
};
    const audittransection = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };
        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }
    }

    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details.AUTR_Message;
        const AUTR_AuditType = details.AUTR_AuditType;
        if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {
            console.log("null--------")
            const data = {
                AUTR_ScreenName: "Company Group Master List",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: null,
                AUTR_CompanyGrpId: null,
                AUTR_CompanyID: null,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };
            console.log(data)
            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
                console.log('Success:', response.data);
                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        } else {
            console.log("null--------")
            const data = {
                AUTR_ScreenName: "Company Group Master List",
                AUTR_OldValue: AUTR_OldValue,
                AUTR_NewValue: AUTR_NewValue,
                AUTR_Message: AUTR_Message,
                AUTR_UserID: UM_UserId,
                AUTR_UserName: UM_UserCode,
                AUTR_TimeStamp: currentTimestamp,
                AUTR_AuditType: AUTR_AuditType,
                AUTR_SCPID: selectedScpId,
                AUTR_CompanyGrpId: UM_CompanyID,
                AUTR_CompanyID: UM_CompanyID,
                AUTR_CreatedBy: UM_UserId,
                AUTR_CreatedDateTime: currentTimestamp
            };
            console.log(data)
            try {
                const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
                console.log('Success:', response.data);
                return response.data;
            } catch (error) {
                console.error('Error:', error);
            }
        }

    };

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Company Group Master List:", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    useEffect(() => {
        const getUserdata = async () => {
            try {
                const reqData = await fetch(`${config.API_URL}/CGM`, {
                    method: 'GET',
                });

                if (reqData.ok) {
                    const resData = await reqData.json();
                    console.log('List of companies', resData);
                    logAction('Get CGM List data from API')
                    setUserData(resData);
                } else {
                    logAction('Error in Getting CGM List data from API', true)
                    console.error('Error fetching the company list');
                }
            } catch (error) {
                logAction('Error in Getting CGM List data from API', true)
                console.log('Failed to fetch data:', error);
                setMessage('Please check Data');
            }
        };
        getUserdata();
    }, [message]);

    const handleConfirmStatusChange = (CGM_ID) => {
        setCompanyIdToSuspend(CGM_ID);
        setShowConfirmation(true);
    };

    const handleCancelAction = () => {
        setCompanyIdToSuspend(null);
        setShowConfirmation(false);
        setRemark(''); // Reset the remark on cancellation
        setRemarkError(false);
    };

    // const handleConfirmAction = async () => {
    //     if (companyIdToSuspend) {
    //         if (remark.trim() === '') {
    //             setRemarkError(true);
    //             return; // Do not proceed if remark is empty
    //         }

    //         console.log(companyIdToSuspend);
    //         if (!companyIdToSuspend) return;

    //         try {
    //             const updateStatusData = await fetch(`${config.API_URL}/CGM/Suspend/${companyIdToSuspend.CGM_ID}`, {
    //                 method: 'PUT',
    //                 headers: { 'content-type': 'application/json' },
    //                 body: JSON.stringify({
    //                     CGM_SuspendRemark: remark,
    //                 }),
    //             });

    //             if (updateStatusData.ok) {
    //                 const details = {
    //                     AUTR_Message: `${companyIdToSuspend.CGM_CompanyGroupName} Suspend`,
    //                     AUTR_AuditType: "Suspend",
    //                 };
    //                 let id = await audittrailpost(details);
    //                 const details1 = {
    //                     AUTRN_ParamererName: "Suspend",
    //                     AUTRN_ID: id,
    //                     AUTRN_NewValue: "Suspend",
    //                     AUTRN_OldValue: (companyIdToSuspend.CGM_CompanyGroupStatus === 1) ? "Active" :
    //                         (companyIdToSuspend.CGM_CompanyGroupStatus === 2) ? "Inactive" : "Unknown"
    //                 };
    //                 audittransection(details1);

    //                 showToast('success',`Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} suspended successfully.`);
    //                 logAction(`handleConfirmAction(): Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} suspended successfully.`);
    //                 setRemark('');
    //                 setUserData(prevUserData => {
    //                     const updatedUserData = prevUserData.map(item => {
    //                         if (item.CGM_ID === companyIdToSuspend.CGM_ID) {
    //                             return { ...item, CGM_CompanyGroupStatus: 3 };
    //                         }
    //                         return item;
    //                     });
    //                     return updatedUserData;
    //                 });
    //             } else if (updateStatusData.status === 400) {
    //                 showToast('error',`You cannot suspend the Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} because reference exists in Company Master.`);
    //                 logAction("handleConfirmAction(): Error in Status updated", true);
    //                 console.error('Error updating status:', await updateStatusData.text());
    //             } else {
    //                 showToast('error',`Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} could not be suspended successfully.`);
    //                 logAction("handleConfirmAction(): Error in Status updated", true);
    //                 console.error('Error updating status:', updateStatusData.statusText);
    //             }
    //         } catch (err) {
    //             console.log('Network error:', err);
    //             showToast('error',`Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} could not be suspended successfully.`);
    //             logAction("handleConfirmAction(catch): Error in Status updated", true);
    //         }
    //     }
    //     setRemark('');
    //     setShowConfirmation(false);

    // };
const handleConfirmAction = async () => {
  if (!companyIdToSuspend) return;

  if (remark.trim() === '') {
    setRemarkError(true);
    return;
  }

  try {
    const response = await fetch(
      `${config.API_URL}/CGM/Suspend/${companyIdToSuspend.CGM_ID}`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          CGM_SuspendRemark: remark,
        }),
      }
    );

    if (response.ok) {
      const details = {
        AUTR_Message: `${companyIdToSuspend.CGM_CompanyGroupName} Suspend`,
        AUTR_AuditType: "Suspend",
      };
      let id = await audittrailpost(details);

      const details1 = {
        AUTRN_ParamererName: "Suspend",
        AUTRN_ID: id,
        AUTRN_NewValue: "Suspend",
        AUTRN_OldValue:
          companyIdToSuspend.CGM_CompanyGroupStatus === 1
            ? "Active"
            : companyIdToSuspend.CGM_CompanyGroupStatus === 2
            ? "Inactive"
            : "Unknown",
      };
      audittransection(details1);

      showToast('success',
        `Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} suspended successfully.`
      );

      logAction(
        `handleConfirmAction(): Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} suspended successfully.`
      );

      setUserData(prev =>
        prev.map(item =>
          item.CGM_ID === companyIdToSuspend.CGM_ID
            ? { ...item, CGM_CompanyGroupStatus: 3 }
            : item
        )
      );

    // } else {
    //   // ✅ Read exact backend error message
    //   const errorMsg = await response.text();
    //   showToast('error',errorMsg);
    //   logAction("handleConfirmAction(): Error in Status updated", true);
    } else {
  const backendMsg = await response.text();

  // Remove generic prefix if backend already has one
  let reason = backendMsg;

  if (backendMsg.toLowerCase().includes('because')) {
    reason = backendMsg.split('because')[1].trim();
  }

  showToast('error',
    `You cannot suspend the Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} because ${reason}`
  );

  logAction("handleConfirmAction(): Error in Status updated", true);
    }
  } catch (err) {
    console.error('Network error:', err);
    showToast('error',
      `Company Group : ${companyIdToSuspend.CGM_CompanyGroupName} could not be suspended successfully.`
    );
    logAction("handleConfirmAction(catch): Error in Status updated", true);
  } finally {
    setRemark('');
    setShowConfirmation(false);
  }
};

    const handleFirstFilterChange = (event) => {
        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');

        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);
        logAction("handleFirstFilterChange(): first filter used")
    };

    const handleSecondFilterChange = (event) => {
        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');

        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);
        logAction("handleSecondFilterChange(): second filter used")

    };

    const handleStatusFilterChange = (event) => {
        const value = event.target.value;
        logAction("handleStatusFilterChange(): Status is changed in the dropdown");
        setStatusFilter(value);
        logAction("handleStatusFilterChange(): Data filtered according to the selected status");
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            case 3:
                return 'Suspend';
            default:
                return '';
        }
    };

    const filteredListData = userData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue =
            getStatusLabel(item.CGM_CompanyGroupStatus);
        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'CGM_CompanyGroupStatus' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'CGM_CompanyGroupStatus' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'CGM_CompanyGroupStatus' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'CGM_CompanyGroupStatus' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));
        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const handleRemarkChange = (e) => {
        const value = e.target.value;
        setRemark(value);
        if (remarkError && value.trim() !== '') {
            setRemarkError(false); // Clear the error once the user starts typing
        }
    };

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    return (
        <React.Fragment>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className="main_container">
                <h4 className="formHeading">
                    Company Group Master
                </h4>
                <p>{message}</p>

                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstFilterChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('firstFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input type="text"
                        className='search-input'
                        value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondFilterChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('secondFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input type="text"
                        className='search-input'
                        value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder='Search' />
                    <div className='select-container_list'>

                        <CustomDropdown
                            options={[
                                { value: 'Active', label: 'Active' },
                                { value: 'Inactive', label: 'Inactive' },
                                { value: 'Suspend', label: 'Suspend' }
                            ]}
                            value={statusFilter}
                            onChange={handleStatusFilterChange}
                            name="statusFilter"
                            placeholder="--Select Status--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('statusFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                </div>

                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Company Group Name</th>
                                <th>Company Group Code</th>
                                <th>Company Group Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {filteredListData.length === 0 ? (
                            <tbody >
                                <tr>
                                    <td colSpan="9">No Records Found</td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {currentItems.map((user, index) => (
                                    <tr key={index}>
                                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                        <td>{user.CGM_CompanyGroupName}</td>
                                        <td>{user.CGM_CompanyGroupCode}</td>
                                        <td>
                                            {user.CGM_CompanyGroupStatus === 1 && 'Active'}
                                            {user.CGM_CompanyGroupStatus === 2 && 'Inactive'}
                                            {user.CGM_CompanyGroupStatus === 3 && 'Suspend'}
                                        </td>
                                        <td>
                                            {/* {user.CGM_CompanyGroupStatus !== 3 && (
                                                <Link to={`/cgmedit/${user.CGM_ID}`} className="" title='Edit'>
                                                    <Image src={Icon3} alt="pencil" className="editicon" />
                                                </Link>
                                            )} */}

                                            {user.CGM_CompanyGroupStatus !== 3 ? (
                                              <>
                                               <Link to={`/cgmedit/${user.CGM_ID}`} className="" title='Edit'>
                                                    <Image src={Icon3} alt="pencil" className="editicon" />
                                                </Link>
                                                <img
                                                    src={Icon4}
                                                    alt="suspendremovebg"
                                                    className="suspendicon"
                                                    style={{ cursor: 'pointer', margin: '0px' }}
                                                    onClick={() => handleConfirmStatusChange(user)}
                                                    title='Suspend'
                                                />
                                              </>
                                            )
                                                : (<span style={{ color: '#465a64' }}>-</span>
                                                )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)} disabled={currentPage === 1 || filteredListData.length === 0}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1 || filteredListData.length === 0}>Previous</button>
                    </li>
                    {filteredListData.length > 0 &&
                        Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                            <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                                <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                            </li>
                        ))
                    }
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0}>Next</button>
                    </li>
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))} disabled={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0}>Last</button>
                    </li>
                </ul>


            </div>
            <Link to={`/dashboard/companygroupmaster`} type='button' className="back_btn">
                BACK
            </Link>
            {showConfirmation && (
                <div className="popup_overlay">

                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4 >Are you sure you want to suspend this Company Group : {companyIdToSuspend.CGM_CompanyGroupName} ? </h4>
                        <div className='remark_container'>
                            <span className='me-3 remark_label'>Remark:  {remarkError && <span style={{ color: 'red' }}>*</span>}</span>
                            <textarea
                                type='text'
                                className='remark_text'
                                value={remark}
                                onChange={handleRemarkChange}
                                placeholder="Enter suspend remark"
                                style={{
                                    border: '1px solid #ced4da',
                                    padding: '10px',
                                    fontSize: '16px',
                                    resize: 'none',  // Keep this if you want to prevent resizing
                                    overflow: 'auto',  // Enable scrollbars when content overflows
                                    transition: 'height 0.3s',
                                    borderRadius: "5px",
                                    outline: "none"
                                }}
                            />
                        </div>
                        <div className="popup_btn_container">
                            <button className="yes_btn " onClick={() => handleConfirmAction()}>Yes</button>
                            <button className="no_btn " onClick={() => handleCancelAction()}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default CGMList;
